import { Component } from "vue-property-decorator";
import Template from "@/components/BaseCurd/template";
import {
  WorkStationServiceProxy,
  WorkStationDTO,
} from "@/service-proxies/app-v2/workStation.service-proxies";

enum Codes {
  空,
  机器,
  人工,
}

const service = new WorkStationServiceProxy();

@Component
export default class Employee extends Template {
  name = "workStation";
  options = {
    retrieve: (current, keyWords, size) => {
      return service.getPageWorkStations(
        current,
        new WorkStationDTO({
          filter: keyWords,
        }),
        size
      );
    },
    search: service.getWorkStation.bind(service),
    create: service.createWorkStation.bind(service),
    update: (data) => {
      const id = data.id;
      delete data.id;
      return service.updateWorkStation(data, id);
    },
    delete: service.deleteWorkStation.bind(service),
  };
  acl = {
    create: "page_workstation_create",
    update: "page_workstation_update",
    delete: "page_workstation_delete",
  };

  render() {
    return this.customRender();
  }

  get columns() {
    return [
      { title: this.$t("page_workstation_code"), dataIndex: "code", width: 300 },
      { title: this.$t("page_workstation_name"), dataIndex: "name", width: 300 },
      {
        title: this.$t("page_workstation_type"),
        dataIndex: "type",
        customRender: (text) => Codes[text],
      },
    ];
  }

  get schema() {
    return {
      code: {
        label: this.$t("page_workstation_code"),
        type: "input",
        placeholder: this.$t("page_workstation_add_code"),
        props: {
          maxLength: 32,
        },
        rules: [
          {
            required: true,
            message: this.$t("page_workstation_add_code"),
          },
        ],
        disabled: true,
      },
      name: {
        label: this.$t("page_workstation_name"),
        type: "input",
        placeholder: this.$t("page_workstation_add_name"),
        props: {
          maxLength: 32,
        },
        rules: [
          {
            required: true,
            message: this.$t("page_workstation_add_name"),
          },
        ],
      },
      type: {
        label: this.$t("page_workstation_type"),
        type: "select",
        placeholder: this.$t("page_workstation_add_type"),
        rules: [
          {
            required: true,
            message: this.$t("page_workstation_add_type"),
          },
        ],
        options: [
          {
            label: "空",
            value: 0,
          },
          {
            label: "机器",
            value: 1,
          },
          {
            label: "人工",
            value: 2,
          },
        ],
      },
    };
  }
}
